/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.visflux.chord

import com.macrofocus.common.properties.MutableProperty
import org.mkui.visual.Visual

/** The arcs of the nodes and links of a chord diagram. */
interface ChordModel<Node, Link, Column> {
    enum class PropertyType {
        MinimizedCrossing
    }

    /** The angle between the arcs of two nodes, in degrees. */
    val arcPadding: Double

    /** Whether the links of a node are ordered so that the ribbons cross as little as possible. */
    val minimizedCrossing: MutableProperty<Boolean>

    val nodesVisual: Visual<Node, Column>?
    val linksVisual: Visual<Link, Column>?

    val nodes: Iterable<Node>

    fun getLinks(node: Node): Iterable<Link>

    /** The arc of a node. */
    fun getArc(node: Node): Arc?

    /** The part of the arc of [from] taken by its link to [to]. */
    fun getArc(from: Node, to: Node): Arc?

    fun getFrom(link: Link): Node
    fun getTo(link: Link): Node
    fun getNodeSize(node: Node): Double
    fun getLinkSize(link: Link): Double

    fun addChordListener(listener: ChordListener)
    fun removeChordListener(listener: ChordListener)
}

/** An arc of the circle, in degrees clockwise from the top. */
class Arc(val startAngle: Double, val extent: Double) {
    override fun toString(): String = "Arc{startAngle=$startAngle, extent=$extent}"
}

interface ChordListener {
    fun chordChanged()
}
